<template>

<div>
    <div class="row">
        <div class="col-12 d-flex justify-content-center">
            <ul class="list-inline d-flex align-items-center files-view">
                <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                    <span class="icon icon-list"></span>
                </li>

                <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                    <span class="icon icon-grid"></span>
                </li>
            </ul>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h5 class="group-title title">
                <span>Обща информация</span>
            </h5>
        </div>
    </div>

    <div v-if='!isReady' class="d-flex justify-content-center">
        <img src='/resources/loader.svg'>
    </div>

    <div v-if='isReady'>

        <div v-for='ft in fileTypes'>
            <div class="row">
                <div class="col-12">
                    <h6 class="group-sub-title title">
                        {{ ft.name }}
                    </h6>

                    <div id="files-holder" :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                        
                        <div v-if='!files[ ft.id ].length' class="row">
                            <div class="col-md-12 file-item file-no">
                                <div class="alert alert-info">
                                    <span class="icon icon-info"></span> 
                                    Няма качени файлове в тази категория.
                                </div>
                            </div>
                        </div>
                        
                        <div v-if='files[ ft.id ].length'>

                            <file-grid :files='files[ ft.id ]' 
                                   :lightBoxId='ft.id'
                                   :params='{ ftid : ft.id }'
                                   :conf='{ edit : canEdit }'
                                   :info='"Качено от възложител в Обща информация"'></file-grid>
                       
                        </div>        

                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="row">
                <div v-for='phase in $store.state.phases'
                     v-if='typeof phaseFiles[ phase.id ] == "object"' class="col-12 mb-3">
                
                    <h5 class="group-title title">
                        <span>{{ phase.name }}</span>
                    </h5>

                    <div class="col-12">
                        <div :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                            <file-grid :files='phaseFiles[ phase.id ]' 
                                   :lightBoxId='phase.id + "phf"'
                                   :params='{ ftid : phase.id + "-ph" }'
                                   :conf='{ edit : canEdit }'
                                   :info='"Качено от изпълнител"'></file-grid>
                        </div>
               
                    </div>


                
                </div>

            </div>
        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();

            bus.$emit("set-title", "Всички файлове");

            console.log( this.$parent.project);
        },

        created() {
           
        },

        //Project ID
        props : ['pid'],

        data() {
            return {

                isReady     : false,
                files       : false,
                phaseFiles  : [],
                fileTypes   : [],
                grid        : false,
                canEdit     : false,
            }
        },

        methods : {          

            getData() {
                var me = this;

                me.ajax.call('prj:fls', { p : this.pid }, (r) => {
                    
                    if( r.status == 'success' ) {
                        var files = {};
                        me.fileTypes = r.data.ft;

                        for( var i in me.fileTypes ) {
                            files[ me.fileTypes[i].id ] = [];
                        }

                        for( var i in r.data.f ) {
                            files[ r.data.f[i].type_id ].push( r.data.f[i] );
                        }

                        me.files = files;  
                        me.phaseFiles = r.data.ph;
                    }

                    me.isReady = true;
                })
            },

            getContent( f ) {
                var str = "<div class='file-uploader'><span class='icon icon-user'></span> Качено от изпълнител в Идеен проект</div><div class='file-date'><span class='icon icon-calendar'></span>"+ this.bgDate( f.created_at ) +"</div><div class='file-size'>"+ f.size +"</div>"
            }

        }

    }
</script>